import React, { useState } from 'react';
import TreasuryRealDataTable from '@/components/tables/TreasuryRealDataTable';
import TreasuryDashboard from '@/components/TreasuryDashboard';
import { UserRole } from '@/types';

interface TreasuryPageProps {
    currentUserRole: UserRole;
    currentUserId: string;
    onNavigate: (view: string) => void;
}

const TreasuryPage: React.FC<TreasuryPageProps> = ({ onNavigate }) => {
  const [activeView, setActiveView] = useState('management');

  return (
    <div className="container mx-auto px-4">
        <div className="flex items-center space-x-4 mb-8">
          <button
            onClick={() => setActiveView('management')}
            className={`font-bold py-2 px-4 rounded ${activeView === 'management' ? 'bg-blue-500 text-white' : 'bg-gray-700 text-gray-300'}`}>
            Management Dashboard
          </button>
          <button
            onClick={() => setActiveView('history')}
            className={`font-bold py-2 px-4 rounded ${activeView === 'history' ? 'bg-blue-500 text-white' : 'bg-gray-700 text-gray-300'}`}>
            Treasury Ledger
          </button>
        </div>

      {activeView === 'management' && (
        <TreasuryDashboard />
      )}

      {activeView === 'history' && (
        <TreasuryRealDataTable />
      )}
    </div>
  );
};

export default TreasuryPage;
